import React, {useCallback, useState} from 'react';
import {navigate} from '@reach/router';
import classNames from 'classnames';
import ContactInfoForm from './components/ContactInfoForm';
import SegmentationForm from './components/SegmentationForm';

import './OptinForm.scss';

function OptinForm({
  id,
  entry,
  bucket,
  linkColor = 'purple',
  variant = undefined,
  onComplete = () => {},
  onStepComplete = () => {},
  btnText,
  ...props
}) {
  const [step, setStep] = useState(0);
  return (
    <>
      <ContactInfoForm
        onComplete={() => {
          onComplete();
        }}
        id={id}
        variant={variant}
        entry={entry}
        bucket={bucket}
        btnText={btnText}
      />
    </>
  );
}
export default OptinForm;
